import React from "react";
import { Box, Typography } from "@mui/material";
import Navbar from "@/components/home/Navbar";
import WritingWorkspace from "@/components/writing/WritingWorkspace";
import { useParams } from "react-router-dom";

const WritingPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  if (!projectId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          项目ID不存在
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Navbar />
      <WritingWorkspace projectId={projectId} />
    </Box>
  );
};

export default WritingPage;
